module.exports = __webpack_public_path__ + "static/media/logo.a603544f.png";